export default {
  // возвращает cookie с именем name, если есть, если нет, то undefined
  get(name) {
    const matches = document.cookie.match(
      new RegExp(
        '(?:^|; )' +
          name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
          '=([^;]*)'
      )
    );
    return matches ? decodeURIComponent(matches[1]) : undefined;
  },

  // устанавливает cookie с именем name и значением value
  // options - объект с свойствами cookie (expires, path, domain, secure)
  set(name, value, options = {}) {
    let { expires } = options;
    const cookies = [];

    if (typeof expires == 'number' && expires) {
      const date = new Date();
      date.setTime(date.getTime() + expires * 1000);
      expires = options.expires = date;
    }

    if (expires && expires.toUTCString) {
      options.expires = expires.toUTCString();
    }

    value = encodeURIComponent(value);
    cookies.push(`${name}=${value}`);

    for (let propName in options) {
      const propValue = options[propName];

      if (propValue !== true) {
        cookies.push(`${propName}=${propValue}`);
      } else {
        cookies.push(`${propName}`);
      }
    }

    document.cookie = cookies.join(';');
  },

  // удаляет cookie с именем name
  remove(name) {
    this.set(name, '', {
      expires: -1
    });
  }
};
